module.exports = __webpack_public_path__ + "static/media/4pic.84305831.png";